import type { FaireProductEntity } from "../../entity_types/product";

export const p_tkft8gdcx3: FaireProductEntity = {
  token: "p_tkft8gdcx3",
  type: "product",
  name: "Sheepdog Belated Birthday Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/1e066d60284c3c3c1e28ff61f3510de2a42a01451f906f4b19a2be2bbd33a26b.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/67d1e0b12bf1de501db6e6c38d379521dbdd7e7bf01799a0193444bd070fbc2f.png",
    "https://cdn.faire.com/fastly/372273c8c76e4d609bd66e7ae17129709d824886cb5efc3bae1ba73b8459b738.png",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:35:58.736Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
